"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmenitiesValue = exports.FacilitiesValue = exports.ContractTypeValue = exports.SortingValue = exports.SuitableForValue = exports.RoomsValue = exports.RulesValue = exports.HeatingOptions = exports.Options = exports.GenderValue = exports.BillsValue = exports.FurnitureValue = exports.TypeValue = void 0;
var TypeValue;
exports.TypeValue = TypeValue;

(function (TypeValue) {
  TypeValue["PRIVATE_ROOM"] = "private-rooms";
  TypeValue["SHARED_ROOM"] = "shared-rooms";
  TypeValue["APARTMENT"] = "apartment-for-rent";
  TypeValue["STUDIO"] = "studio-for-rent";
})(TypeValue || (exports.TypeValue = TypeValue = {}));

var FurnitureValue;
exports.FurnitureValue = FurnitureValue;

(function (FurnitureValue) {
  FurnitureValue["FURNISHED"] = "furnished";
  FurnitureValue["UNFURNISHED"] = "unfurnished";
})(FurnitureValue || (exports.FurnitureValue = FurnitureValue = {}));

var BillsValue;
exports.BillsValue = BillsValue;

(function (BillsValue) {
  BillsValue["INCLUDED"] = "included";
  BillsValue["EXCLUDED"] = "excluded";
})(BillsValue || (exports.BillsValue = BillsValue = {}));

var GenderValue;
exports.GenderValue = GenderValue;

(function (GenderValue) {
  GenderValue["GIRLS"] = "female";
  GenderValue["BOYS"] = "male";
})(GenderValue || (exports.GenderValue = GenderValue = {}));

var Options;
exports.Options = Options;

(function (Options) {
  Options["NO"] = "no";
  Options["YES"] = "yes";
  Options["DISCUSSABLE"] = "discussable";
  Options["OUTSIDE"] = "outside_only";
  Options["PRIVATE"] = "private";
  Options["SHARED"] = "shared";
})(Options || (exports.Options = Options = {}));

var HeatingOptions;
exports.HeatingOptions = HeatingOptions;

(function (HeatingOptions) {
  HeatingOptions["CENTRAL"] = "central";
  HeatingOptions["GAS"] = "gas";
  HeatingOptions["WOOD_STOVE"] = "wood_stove";
  HeatingOptions["ELECTRICAL"] = "electrical";
  HeatingOptions["NO"] = "no";
})(HeatingOptions || (exports.HeatingOptions = HeatingOptions = {}));

var RulesValue;
exports.RulesValue = RulesValue;

(function (RulesValue) {
  RulesValue["SMOKING"] = "smoking_allowed";
  RulesValue["PETS"] = "pets_allowed";
  RulesValue["INSTRUMENT"] = "playing_instrument_allowed";
})(RulesValue || (exports.RulesValue = RulesValue = {}));

var RoomsValue;
exports.RoomsValue = RoomsValue;

(function (RoomsValue) {
  RoomsValue["ONE"] = "1";
  RoomsValue["TWO"] = "2";
  RoomsValue["THREE"] = "3";
  RoomsValue["FOUR_AND_MORE"] = "4+";
})(RoomsValue || (exports.RoomsValue = RoomsValue = {}));

var SuitableForValue;
exports.SuitableForValue = SuitableForValue;

(function (SuitableForValue) {
  SuitableForValue["STUDENTS"] = "students";
  SuitableForValue["WORKING_PROFESSIONALS"] = "working-professionals";
  SuitableForValue["COUPLES"] = "couples";
})(SuitableForValue || (exports.SuitableForValue = SuitableForValue = {}));

var SortingValue;
exports.SortingValue = SortingValue;

(function (SortingValue) {
  SortingValue["BestMatch"] = "bestMatch";
  SortingValue["MostRecent"] = "mostRecent";
  SortingValue["LowToHigh"] = "lowToHigh";
  SortingValue["HighToLow"] = "highToLow";
})(SortingValue || (exports.SortingValue = SortingValue = {}));

var ContractTypeValue;
exports.ContractTypeValue = ContractTypeValue;

(function (ContractTypeValue) {
  ContractTypeValue["Daily"] = "daily";
  ContractTypeValue["Fortnightly"] = "fortnightly";
  ContractTypeValue["Monthly"] = "monthly";
  ContractTypeValue["Unknown"] = "unknown";
})(ContractTypeValue || (exports.ContractTypeValue = ContractTypeValue = {}));

var FacilitiesValue;
exports.FacilitiesValue = FacilitiesValue;

(function (FacilitiesValue) {
  FacilitiesValue["PRIVATE_BATHROOM"] = "private_bathroom";
  FacilitiesValue["BALCONY_TERRACE"] = "balcony_terrace";
  FacilitiesValue["GARDEN"] = "garden";
  FacilitiesValue["KITCHEN"] = "kitchen";
  FacilitiesValue["PET_FRIENDLY"] = "pets_friendly";
  FacilitiesValue["PARKING"] = "parking";
  FacilitiesValue["WHEELCHAIR_ACCESSIBLE"] = "wheelchair_accessible";
  FacilitiesValue["BASEMENT"] = "basement";
})(FacilitiesValue || (exports.FacilitiesValue = FacilitiesValue = {}));

var AmenitiesValue;
exports.AmenitiesValue = AmenitiesValue;

(function (AmenitiesValue) {
  AmenitiesValue["TV"] = "tv";
  AmenitiesValue["DESK"] = "desk";
  AmenitiesValue["DISHWASHER"] = "dishwasher";
  AmenitiesValue["WASHING_MACHINE"] = "washing_machine";
  AmenitiesValue["DRYER"] = "dryer";
  AmenitiesValue["AIR_CONDITIONING"] = "ac";
  AmenitiesValue["HEATING"] = "heating";
})(AmenitiesValue || (exports.AmenitiesValue = AmenitiesValue = {}));